import type { AccountType } from '~/types/code/code';

/**
 * アカウント区分の列挙型
 */
export const AccountTypeEnum = {
  /** トラックドライバー */
  DRIVER: 'DRIVER',
  /** 臨時トラックドライバー */
  DRIVER_GUEST: 'DRIVER_GUEST',
  /** 利用運送事業者事務員 */
  OFFICE: 'OFFICE',
  /** JRF社員 */
  JRF: 'JRF',
  /** JRF協力会社 */
  PARTNER: 'PARTNER',
  /** 法人アカウント */
  CORPORATION: 'CORPORATION',
} as const satisfies Record<string, AccountType>;

/**
 * ドライバー系のアカウント区分
 */
const DRIVER_ACCOUNT_TYPES = [
  AccountTypeEnum.DRIVER,
  AccountTypeEnum.DRIVER_GUEST,
] as const;

/**
 * アカウント区分がドライバー系かどうかを判定
 * @param accountType - アカウント区分
 * @returns ドライバー系の場合true
 */
export const isDriverAccount = (accountType: string | undefined | null): boolean => {
  return DRIVER_ACCOUNT_TYPES.includes(accountType as typeof DRIVER_ACCOUNT_TYPES[number]);
};

const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  DRIVER: 'トラックドライバー',
  OFFICE: '利用運送事業者',
  DRIVER_GUEST: '臨時トラックドライバー',
  JRF: '当社社員',
  PARTNER: '協力会社',
  CORPORATION: '法人',
};

/**
 * アカウント区分ラベルを取得する
 *
 * @param accountType アカウント区分
 * @returns アカウント区分ラベル
 */
export const getAccountTypeLabel = (accountType: AccountType) =>
  ACCOUNT_TYPE_LABELS[accountType] ?? '';
